import { Icon } from '@livable/saas-react-components';
import { FormControl, InputAdornment, InputLabel, OutlinedInput, TextField, Typography } from '@mui/material';
import React from 'react';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
export const Unit = observer(_ref => {
  let id = _ref.id,
    propertyAddress = _ref.propertyAddress;
  const store = useStore();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.unit
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Unit: ", store.residenciesMultiActionStore.getResidentById(id).number), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, store.residenciesMultiActionStore.getResidentById(id).name), !!propertyAddress && /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, propertyAddress)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    className: classes.smallField
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "unit-current-occupancy"
  }, "Current"), /*#__PURE__*/React.createElement(OutlinedInput, {
    disabled: true,
    label: "Current",
    id: "unit-current-occupancy",
    value: store.residenciesMultiActionStore.getResidentById(id).occupancy,
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "lock-locked"
    }))
  })), /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    label: "New",
    type: "text",
    onKeyPress: event => {
      if (!/[1-8]/.test(event.key)) {
        event.preventDefault();
      }
    },
    value: store.residenciesMultiActionStore.getResidentById(id)._newoccupancy,
    onChange: e => {
      if (e.target.value.length > 1) return;
      store.residenciesMultiActionStore.setNewOccupancyById(id, e.target.value);
    },
    error: store.residenciesMultiActionStore.getResidentById(id)._newoccupancy.trim().length === 0,
    className: classes.smallField
  })));
});